import { useRef, useState, useCallback, useEffect, useMemo } from 'react';

function useTooltip({ showOnlyOnEllipsis, lineClamp, fallbackPlacements = DEFAULT_FALLBACK_PLACEMENTS, }) {
    const ref = useRef(null);
    const [hasEllipsis, setHasEllipsis] = useState(false);
    const shouldDisableTooltip = showOnlyOnEllipsis && !hasEllipsis;
    const handleRef = useCallback((element) => {
        if (!ref.current) {
            ref.current = element;
        }
        if (showOnlyOnEllipsis && element) {
            const { offsetWidth, scrollWidth, offsetHeight, scrollHeight } = element;
            if (lineClamp === undefined || lineClamp === 1) {
                setHasEllipsis(offsetWidth < scrollWidth);
            }
            else {
                setHasEllipsis(offsetHeight < scrollHeight);
            }
        }
    }, [showOnlyOnEllipsis, lineClamp]);
    useEffect(() => {
        addEventListener("resize", () => handleRef(ref.current));
        return () => removeEventListener("resize", () => handleRef(ref.current));
    }, [handleRef]);
    const popperProps = useMemo(() => ({
        modifiers: [
            {
                name: "flip",
                enabled: true,
                options: {
                    fallbackPlacements,
                    altBoundary: false,
                    rootBoundary: "viewport",
                },
            },
        ],
    }), [fallbackPlacements]);
    return {
        popperProps,
        shouldDisableTooltip,
        handleRef,
    };
}
const DEFAULT_FALLBACK_PLACEMENTS = [
    "left",
    "bottom",
    "top",
    "right",
];

export { useTooltip };
//# sourceMappingURL=useTooltip.js.map
